import { createResourceQuery } from '@funtech-int/rival';
import {
    WatchingProgress,
    watchingProgressQuery,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { GraphqlClient } from '@/shared/lib/graphqlClient';

interface WatchingProgressQueryVariables {
    contentId: string;
    billingFeaturesCount: number;
    key?: number;
}

interface GQLQueryParams {
    client: GraphqlClient;
    variables: WatchingProgressQueryVariables;
}

export const watchingProgressResourceQuery = createResourceQuery<
    GQLQueryParams,
    WatchingProgress | undefined | null
>({
    key(ctx) {
        return [watchingProgressQuery.name, JSON.stringify(ctx.variables)].join(':');
    },
    fetch(ctx) {
        return ctx.client
            .fetch({
                operation: watchingProgressQuery,
                variables: {
                    contentId: ctx.variables.contentId,
                },
            })
            .then(({ data }) => data);
    },
    toJSON(data) {
        return data as any;
    },
    hydrate(data: any) {
        return watchingProgressQuery.hydrate(data) as any;
    },
});
